<template lang="pug">
.episodes-module
  .episode-title {{name}}
  slot
  .episode-list-wrap
    vue-scroll(ref="vs" @handle-scroll="handleScroll" @handle-scroll-complete="handleComplete")
      .episode-list(v-if="list.length")
        //- .episode-item.episode-item-fullwidth(v-for="(item, index) in 60" :key="index")
        .episode-item(v-for="(item, index) in list" :class="{'episode-item-fullwidth': showSetName, 'episode-item-active': currentEpisode.id === item.id}"  :key="position + index + item.id" @click="episodeChanged(item, index)")
          img.sign(v-if="item.showAppLabel" src="https://img.loklok.video/fe/315bbc14-d039-48c2-b3cb-fe98e989d14c/sign_app.png")
          .actived-icon.iconfont.icon-ic_play_play(v-if='currentEpisode.id === item.id')
          span {{showSetName ? (item.name|| item.seriesNo) : item.seriesNo}}
      fq-ignore(v-else size="mini")
</template>

<script>
export default {
  name: 'Episodes',
  props: {
    name: {
      type: String,
      default: ''
    },
    showSetName: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: []
    },
    currentEpisode: {
      type: Object,
      default: {}
    },
    // 页面有两个Episode组件，比较key重复
    position: {
      type: String,
      default: ''
    }
  },
  methods: {
    episodeChanged(item, index) {
      if (this.currentEpisode.id === item.id) return
      if (item.showAppLabel) {
        this.$emit('getDownloadLink', true)
        return
      }
      this.$emit('episodeChanged', item, index)
    },
    handleComplete() {
      console.log('scroll complete！')
    },
    handleScroll(vertical, horizontal, nativeEvent) {
      console.log('scroll')
    },
    activeScrollToView() {
      const index = this.list.findIndex((item) => item.id === this.currentEpisode.id)
      const needHeight = Math.floor(index / 6) * 58
      this.$refs.vs.scrollTo({ y: needHeight }, 200)
    }
  },
  mounted() {
    // document.querySelector('.episode-item-active').scrollIntoView()
    setTimeout(() => {
      // 集滚动到可视区域
      this.activeScrollToView()
    }, 500)
  }
}
</script>

<style scoped lang="sass">
.episodes-module
  // padding-left: 20px
  // padding-right: 20px
  margin-bottom: 80px
  .episode-title
    max-height: 54px
    font-weight: 900
    font-size: 18px
    line-height: 150%
    color: $mainTextColor
    margin: 20px 22px 20px 20px
    @include ellipsis-multi(2)
  .episode-list-wrap
    width: 100%
    height: 397px
    padding: 0px 0px 20px 20px
  .episode-list
    width: 100%
    user-select: none
    padding-inline-start: 0
    @include base-flex
    flex-wrap: wrap
    // margin-bottom: 28px
    .episode-item
      width: 48px
      height: 48px
      line-height: 48px
      text-align: center
      font-size: 18px
      font-weight: 900
      color: #DEE4E9
      display: block
      background: $backgroundColor1
      margin-right: 10px
      margin-bottom: 10px
      border-radius: 8px
      position: relative
      cursor: pointer
      .sign
        position: absolute
        right: 0
        top: 0
        width: 18px
        height: 12px
        border-top-right-radius: 8px
      .actived-icon
        font-size: 24px
        color: $mainColor
        display: block
        position: absolute
        background: $backgroundColor1
        position: absolute
        border-radius: 8px
        bottom: 0
        left: 0
        right: 0
        top: 0
      .actived-layer
        display: none
    .episode-item:nth-child(6n+ 6)
      margin-right: 0
    .episode-item-fullwidth
      width: 330px
      text-align: left
      display: flex
      justify-content: center
      padding: 0 12px
      .actived-icon
        color: $mainColor
        font-size: 22px
        display: block
        position: relative
      span
        width: 274px
        @include ellipsis
</style>
